import Vue from 'vue'
import Router from 'vue-router'
import Assignment from './views/Assignment.vue'
import Introduction from '@/components/assignments/Introduction.vue'
import Herocard from '@/components/assignments/Herocard.vue'
import Video from '@/components/assignments/Video.vue'
import Start from '@/components/assignments/Start.vue'
import Step from '@/components/assignments/Step.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkname: "home" */ './views/Home.vue')
    },
    {
      name: 'update-browser',
      path: '/update-browser',
      component: () => import(/* webpackChunkname: "browser" */ './views/UpdateBrowser.vue')
    },
    {
      path: '/assignment/:assignment',
      component: Assignment,
      children: [
        {
          path: '',
          component: Start
        },
        {
          path: 'introduction',
          component: Introduction
        },
        {
          path: 'herocard',
          component: Herocard
        },
        {
          path: 'video',
          component: Video
        },
        {
          path: 'step/:step',
          component: Step
        },
        {
          path: 'confirmation',
          component: () => import(/* webpackChunkname: "confirmation" */ './components/assignments/Confirmation.vue')
        }
      ]
    }
  ]
})
